import { render, staticRenderFns } from "./reject.vue?vue&type=template&id=4ddf0d26&scoped=true"
import script from "./reject.vue?vue&type=script&lang=js"
export * from "./reject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddf0d26",
  null
  
)

export default component.exports